import { Box } from "@mui/material";

enum SizingWrapperStyle {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
  INHERIT = "inherit",
}

interface ISizingWrapperProps {
  size?: SizingWrapperStyle;
  center?: boolean;
}

interface IProps extends ISizingWrapperProps {
  children: React.ReactNode;
}

const SizingWrapper: React.FC<IProps> = (props) => {
  const { children, size = SizingWrapperStyle.MEDIUM, center = false } = props;
  const SizingWrapperStyleMap: Record<SizingWrapperStyle, number | string> = {
    [SizingWrapperStyle.SMALL]: 150,
    [SizingWrapperStyle.MEDIUM]: 250,
    [SizingWrapperStyle.LARGE]: 350,
    [SizingWrapperStyle.INHERIT]: "inherit",
  };

  return (
    <Box
      sx={{
        width: { xs: "100%", sm: SizingWrapperStyleMap[size] },
        ...(center && {
          display: { xs: "flex", sm: "block" },
          justifyContent: { xs: "center" },
          alignItems: { xs: "center" },
        }),
      }}
    >
      {children}
    </Box>
  );
};

export { SizingWrapper, type ISizingWrapperProps, SizingWrapperStyle };
